import { Question } from '../types/quiz';

export const QUIZ_LIVE_QUESTION_COUNT_KEY = (presentationId: string) =>
  `quiz_live_question_count_${presentationId}`;

function hasQuestionText(question: Question): boolean {
  return Boolean(question.question?.trim());
}

function hasAtLeastOneAnswerOption(question: Question): boolean {
  return question.options?.some((option) => Boolean(option.option?.trim())) ?? false;
}

/** Questions that are shown during a live quiz (same rules as quiz-moderator save). */
export function getLiveQuizQuestions(questions: Question[] = []): Question[] {
  const seenIds = new Set<string>();
  const seenQuestionText = new Set<string>();

  const eligible = questions
    .filter(
      (question) =>
        question.visible === true &&
        hasQuestionText(question) &&
        hasAtLeastOneAnswerOption(question)
    )
    .sort((a, b) => a.order - b.order);

  return eligible.filter((question) => {
    if (question.id) {
      if (seenIds.has(question.id)) {
        return false;
      }
      seenIds.add(question.id);
    }

    const textKey = question.question!.trim().toLowerCase();
    if (seenQuestionText.has(textKey)) {
      return false;
    }
    seenQuestionText.add(textKey);

    return true;
  });
}

/** Prefer count saved from quiz-moderator when DB still has orphan rows. */
export function getLiveQuizQuestionsForPresentation(
  presentationId: string,
  questions: Question[] = []
): Question[] {
  const live = getLiveQuizQuestions(questions);
  const savedCount = parseInt(
    localStorage.getItem(QUIZ_LIVE_QUESTION_COUNT_KEY(presentationId)) || '',
    10
  );

  if (Number.isFinite(savedCount) && savedCount > 0 && live.length > savedCount) {
    return live.slice(0, savedCount);
  }

  return live;
}
